import { Box } from '@mui/material'

type props = {
    pages: string[],
    navLinkActiveStyle?: Record<string,any>,
    additionalStyle?: Record<string,any>,
}

const LargeScreenAppBar = ({pages, navLinkActiveStyle, additionalStyle}: props) => {
    return (
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                {/* {pages.map((page) => (
                    <NavBarLink 
                        key={page}
                        to={`/${page.toLowerCase().replaceAll(' ', '-')}`} 
                        page={page} 
                        navLinkActiveStyle={navLinkActiveStyle}
                        additionalStyle={additionalStyle} 
                    />
                ))} */}
        </Box>
    )
}

export default LargeScreenAppBar